import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { SchoolForm } from "../../components/school/SchoolForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import { schools_path } from "../../routes";

export default function SchoolCreate() {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(schools_path), values);
  return (
    <ContentShell title="Neue Schule" onBack={() => router.get(pathWithYearContext(schools_path))}>
      <SchoolForm submitButtonLabel="Erstellen" onSubmit={onSubmit} />
    </ContentShell>
  );
}
